export const normalizeEmail = (value: string): string => value.trim().toLowerCase();
